import { InputDigitSequenceStateType, } from '@kubit/web-ui-components/inputDigitSequence/types';
import { commonStyles } from '../commonStyles';
import { InputDigitSequenceVariant } from '../variants';
export const getDefaultStyles = (FOUNDATIONS, FONT, FONT_FAMILY) => {
    return {
        [InputDigitSequenceVariant.DEFAULT]: {
            [InputDigitSequenceStateType.DEFAULT]: {
                ...commonStyles(FOUNDATIONS, FONT, FONT_FAMILY),
                inputDigitContainer: {
                    ...commonStyles(FOUNDATIONS, FONT, FONT_FAMILY).inputDigitContainer,
                },
            },
            [InputDigitSequenceStateType.DISABLED]: {
                ...commonStyles(FOUNDATIONS, FONT, FONT_FAMILY),
                inputDigitContainer: {
                    ...commonStyles(FOUNDATIONS, FONT, FONT_FAMILY).inputDigitContainer,
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    border_color: FOUNDATIONS.color_accent_disabled_border_100,
                },
            },
            [InputDigitSequenceStateType.BLOCKED_BY_SYSTEM]: {
                ...commonStyles(FOUNDATIONS, FONT, FONT_FAMILY),
                inputDigitContainer: {
                    ...commonStyles(FOUNDATIONS, FONT, FONT_FAMILY).inputDigitContainer,
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    border_color: FOUNDATIONS.color_accent_disabled_border_100,
                },
                inputDigitContainerError: {
                    ...commonStyles(FOUNDATIONS, FONT, FONT_FAMILY).inputDigitContainerError,
                    background_color: FOUNDATIONS.color_feedback_error_bg_200,
                },
                inputDigitTextTypePassword: {
                    ...commonStyles(FOUNDATIONS, FONT, FONT_FAMILY).inputDigitTextTypePassword,
                    font_family: FONT_FAMILY.font_family_digit_password_square,
                },
            },
        },
    };
};
//# sourceMappingURL=default.js.map